// ============================================================
// Add Student Page
// ============================================================

import { Box } from '@mui/material';
import { PageHeader } from '@/components/navigation/PageHeader';
import { usePageMeta } from '@/hooks/usePageMeta';
import { AddStudentWizard } from './components/forms/AddStudentWizard';

export function AddStudentPage() {
  usePageMeta('Add Student', [
    { label: 'Students', path: '/students' },
    { label: 'List', path: '/students/list' },
    { label: 'Add' },
  ]);

  return (
    <Box sx={{ pb: 6 }}>
      <PageHeader 
        title="Admission Form" 
        subtitle="Enroll a new student by filling out the multi-step admission wizard." 
      />
      <AddStudentWizard />
    </Box>
  );
}
